import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { FormInputField, FormModal, ModalFormButtons } from "@components/Form";
import { batchMethodUpdate } from "../api";

interface DeviceBatchEditFormModalProps {
    isOpen: boolean;
    handleClose: () => void;
    device_ids: number[];
    handleSubmit: (device_name: string) => void;
}

export const DeviceBatchEditFormModal: React.FC<DeviceBatchEditFormModalProps> = ({
    handleClose,
    handleSubmit,
    isOpen,
    device_ids,
}) => {
    const { mutateAsync, isLoading } = useMutation(batchMethodUpdate);
    const {
        register,
        setError,
        handleSubmit: handleSubmitForm,
        reset,
        formState: { errors: formErrors },
    } = useForm<{ device_name: string }>();

    const onSubmit: SubmitHandler<{ device_name: string }> = async ({ device_name }) => {
        try {
            await mutateAsync({ device_ids, device_name });
            handleSubmit(device_name);
            handleClose();
        } catch (error) {
            const errorMessage = (error as any).response?.data.message;

            if (!errorMessage) return;
            setError("device_name", {
                type: "api",
                message: errorMessage,
            });
        }
    };
    const closeAndResetModal = () => {
        handleClose();
        reset({ device_name: "" });
    };

    return (
        <>
            <FormModal
                heading={`Edit ${device_ids.length} Device Names`}
                open={isOpen}
                handleClose={closeAndResetModal}
                handleSubmit={handleSubmitForm(onSubmit)}
                icon={<EditIcon />}
            >
                <FormInputField
                    register={register("device_name", {
                        required: "Please enter a new device name",
                    })}
                    label="Device Name"
                    error={Boolean(formErrors.device_name?.message)}
                    helperText={formErrors.device_name?.message}
                    required
                />
                <ModalFormButtons closeFn={closeAndResetModal} text="Submit" isLoading={isLoading} />
            </FormModal>
        </>
    );
};
